import React, { useState, useEffect } from 'react'
import { Modal, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const RenameAdModal = ({ visible, ad, onSubmit, onCancel }) => {
  const { t } = useTranslation()
  const [name, setName] = useState('')

  useEffect(() => {
    if (visible) setName(ad ? ad.name : '')
  }, [visible, ad])

  const trimmed = name.trim()

  const handleOk = () => {
    if (!trimmed) return
    onSubmit(trimmed)
  }

  return (
    <Modal
      title={t('Rename ad')}
      visible={visible}
      okText={t('Save')}
      cancelText={t('Cancel')}
      onOk={handleOk}
      onCancel={onCancel}
      okButtonProps={{ disabled: !trimmed }}
      destroyOnClose
    >
      <div style={{ padding: 21 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>{t('Ad name')}</label>
        <Input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={handleOk}
        />
      </div>
    </Modal>
  )
}

export default RenameAdModal
